import { render, staticRenderFns } from "./UnderInvestigationReports.vue?vue&type=template&id=521dcaf4&scoped=true"
import script from "./UnderInvestigationReports.vue?vue&type=script&lang=js"
export * from "./UnderInvestigationReports.vue?vue&type=script&lang=js"
import style0 from "./UnderInvestigationReports.vue?vue&type=style&index=0&id=521dcaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521dcaf4",
  null
  
)

export default component.exports